import api from "../api/client";
import React, { useState } from "react";
import "./LoginForm.css";
import backgroundImg from "../assets/bg-golf.jpg";
import { useNavigate } from "react-router-dom";

const LoginForm = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const { data } = await api.post("/auth/login", { email, password });

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      try {
        document.cookie = `gp_auth=1; path=/`;
        document.cookie = `gp_token=${data.token}; path=/`;
        document.cookie = `gp_user=${encodeURIComponent(JSON.stringify({ id: data.user.id, email: data.user.email, role: data.user.role }))}; path=/`;
      } catch {}
      onLoginSuccess(data.user);
      const role = data.user?.role;
      if (role === 'superadmin') return navigate('/superadmin', { replace: true });
      if (role === 'admin') return navigate('/admin', { replace: true });
      return navigate('/', { replace: true });
    } catch (err) {
      // Fallback de demo si el backend no está disponible
      try {
        const demoEmails = {
          'carlos@greenpass.com': 'superadmin',
          'juan@greenpass.com': 'admin',
        };
        const role = demoEmails[email?.trim()?.toLowerCase()] || null;
        if (!role) throw new Error('DEMO_UNAVAILABLE');
        const demoUser = {
          id: 1,
          email,
          role,
          nombre: role === 'superadmin' ? 'Carlos' : 'Juan',
        };
        const demoToken = 'demo-token';
        localStorage.setItem('token', demoToken);
        localStorage.setItem('user', JSON.stringify(demoUser));
        try {
          document.cookie = `gp_auth=1; path=/`;
          document.cookie = `gp_token=${demoToken}; path=/`;
          document.cookie = `gp_user=${encodeURIComponent(JSON.stringify({ id: demoUser.id, email: demoUser.email, role: demoUser.role }))}; path=/`;
        } catch {}
        onLoginSuccess(demoUser);
        return navigate(demoUser.role === 'superadmin' ? '/superadmin' : '/admin', { replace: true });
      } catch {
        setError("Error del servidor");
      }
    }
  };

  return (
    <div
      className="login-container"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.85)), url(${backgroundImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="login-box animate__animated animate__fadeIn">
        <h2 className="text-center mb-4">Bienvenido a Green Pass</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label>Correo electrónico</label>
            <input
              type="email"
              placeholder="cliente@greenpass.com"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label>Contraseña</label>
            <input
              type="password"
              placeholder="••••••••"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Ingresar
          </button>
          {error && <div className="alert alert-danger mt-3">{error}</div>}
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
